import angular from "angular";
import { Lang } from "Roblox";

let gameBadges = angular.module("gameBadges", ["robloxApp", "cursorPagination", "gameBadgesTemplates", "thumbnails"])
    .config(["languageResourceProvider", function (languageResourceProvider) {
        if (Lang.GameBadgesResources) {
            languageResourceProvider.setLanguageKeysFromFile(Lang.GameBadgesResources);
        }
    }]);

export default gameBadges;